<script lang="ts">
  import type { Snippet } from 'svelte';
  import { scale } from 'svelte/transition';
  import { portal, anchored, clickOutside } from './actions';

  interface Props {
    open?: boolean;
    anchor: HTMLElement | null | undefined;
    placement?: 'bottom-start' | 'bottom-end' | 'top-start' | 'top-end' | 'right-start';
    matchWidth?: boolean;
    width?: string;
    padded?: boolean;
    onclose?: () => void;
    children: Snippet;
    class?: string;
  }
  let { open = $bindable(false), anchor, placement = 'bottom-start', matchWidth = false, width, padded = false, onclose, children, class: cls = '' }: Props = $props();
  function close() {
    open = false;
    onclose?.();
  }
</script>

{#if open}
  <div
    use:portal
    use:anchored={{ anchor, placement, matchWidth }}
    use:clickOutside={{ handler: close, ignore: [anchor] }}
    class="pop {cls}"
    class:padded
    style:width
    role="presentation"
    onkeydown={(e) => e.key === 'Escape' && (e.stopPropagation(), close(), anchor?.focus())}
    transition:scale={{ start: 0.97, duration: 110 }}
  >
    {@render children()}
  </div>
{/if}

<style>
  .pop {
    z-index: var(--z-popover);
    background: var(--bg-elevated);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    box-shadow: var(--shadow-lg);
    max-height: min(440px, calc(100vh - 32px));
    max-width: calc(100vw - 16px);
    overflow: auto;
    min-width: 180px;
  }
  .padded { padding: var(--space-3); }
</style>
